module.exports = __webpack_public_path__ + "static/media/fire-hydrant.54f64724.png";


//////////////////
// WEBPACK FOOTER
// ./src/fire-hydrant.png
// module id = 338
// module chunks = 0